import React from 'react';
import classNames from 'classnames';

import Heading from '@components/libraryV2/Heading';

import * as styles from './styles.module.scss';

const SectionTitle = (props) => {
  const { className, description, size, subtitle, tagType, title } = props;

  return (
    <div className={classNames(styles.layout, className)}>
      {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
      <Heading size={size} tagType={tagType}>
        {title}
      </Heading>
      {description ? (
        <div className={styles.descriptionContainer}>
          <div className={styles.description}>{description}</div>
        </div>
      ) : null}
    </div>
  );
};

export default SectionTitle;
